'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$5() {
  this.c2g = null;
  this.c2h = false;
}
export { $c_Lpresto_types$$anon$5 as $c_Lpresto_types$$anon$5 };
$p = $c_Lpresto_types$$anon$5.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$5;
/** @constructor */
function $h_Lpresto_types$$anon$5() {
}
export { $h_Lpresto_types$$anon$5 as $h_Lpresto_types$$anon$5 };
$h_Lpresto_types$$anon$5.prototype = $p;
$p.P = (function() {
  if ((!this.c2h)) {
    this.c2g = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T8($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()));
    this.c2h = true;
  }
  return this.c2g;
});
var $d_Lpresto_types$$anon$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$5, "presto.types$$anon$5", ({
  YA: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_types$$anon$5 as $d_Lpresto_types$$anon$5 };
//# sourceMappingURL=presto.types$$anon$5.js.map
